import { render, staticRenderFns } from "./homePgae.vue?vue&type=template&id=20cbf064&scoped=true"
import script from "./homePgae.vue?vue&type=script&lang=js"
export * from "./homePgae.vue?vue&type=script&lang=js"
import style0 from "./homePgae.vue?vue&type=style&index=0&id=20cbf064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cbf064",
  null
  
)

export default component.exports